module.exports = __webpack_public_path__ + "static/media/svg-2.48a0ae84.svg";